function setToStartTime(date: Date) {
  date.setHours(0)
  date.setMinutes(0)
  date.setSeconds(0)
  date.setMilliseconds(0)
}
function setToEndTime(date: Date) {
  date.setHours(23)
  date.setMinutes(59)
  date.setSeconds(59)
  date.setMilliseconds(999)
}

/**
 * 日期时间范围选择器的快捷选项
 */
 export const DATE_TIME_RANGE_PICKER_SHORTCUTS = [{
  text: '今天',
  value() {
    const start = new Date()
    const end = new Date()
    setToStartTime(start)
    setToEndTime(end)
    return [start, end]
  }
}, {
  text: '最近一周',
  value() {
    const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
    setToStartTime(start)
    setToEndTime(end)
    return [start, end]
  }
}, {
  text: '最近一个月',
  value() {
    const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
    setToStartTime(start)
    setToEndTime(end)
    return [start, end]
  }
}, {
  text: '最近三个月',
  value() {
    const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
    setToStartTime(start)
    setToEndTime(end)
    return [start, end]
  }
}]